/** Imports */
import {z} from 'zod';


/** Zod schemas */
export const zTikTokCreatorInfo = z.object({
    creator_avatar_url: z.string(),
    creator_username: z.string(),
    creator_nickname: z.string(),
    privacy_level_options: z.string().array(),
    comment_disabled: z.boolean(),
    duet_disabled: z.boolean(),
    stitch_disabled: z.boolean(),
    max_video_post_duration_sec: z.number(),
});


/** Types */
export type TikTokCreatorInfo = z.infer<typeof zTikTokCreatorInfo>;
